import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CheckCircle, ArrowRight } from 'lucide-react';
import type { ResetStatus } from './types';

export const LoadingProgress: React.FC = () => (
  <div className="space-y-3 mb-6">
    <div
      className="w-full h-2 rounded-full overflow-hidden"
      style={{ backgroundColor: 'var(--color-border-default)' }}
    >
      <div
        className="h-full rounded-full animate-pulse"
        style={{
          backgroundColor: 'var(--color-accent-teal)',
          width: '60%',
        }}
      />
    </div>
    <p className="text-xs text-center" style={{ color: 'var(--color-text-tertiary)' }}>
      This should only take a moment...
    </p>
  </div>
);

export const SuccessState: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <div
        className="p-4 rounded-lg border flex items-center gap-3"
        style={{
          backgroundColor: 'rgba(16, 185, 129, 0.1)',
          borderColor: 'rgba(16, 185, 129, 0.3)',
        }}
      >
        <CheckCircle className="w-5 h-5 shrink-0" style={{ color: '#10b981' }} />
        <p className="text-sm" style={{ color: '#10b981' }}>
          Signing you in...
        </p>
      </div>

      <button
        onClick={() => navigate('/dashboard')}
        className="btn-primary w-full flex items-center justify-center gap-2 py-3"
      >
        Go to Dashboard
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};

interface ErrorStateProps {
  status: Extract<ResetStatus, 'error' | 'expired'>;
  errorMessage: string;
}

export const ErrorState: React.FC<ErrorStateProps> = ({ status, errorMessage }) => (
  <div className="space-y-3">
    <div
      className="p-4 rounded-lg border mb-4"
      style={{
        backgroundColor:
          status === 'expired' ? 'rgba(245, 158, 11, 0.1)' : 'rgba(239, 68, 68, 0.1)',
        borderColor: status === 'expired' ? 'rgba(245, 158, 11, 0.3)' : 'rgba(239, 68, 68, 0.3)',
      }}
    >
      <p className="text-sm" style={{ color: status === 'expired' ? '#f59e0b' : '#ef4444' }}>
        {errorMessage}
      </p>
    </div>

    <Link to="/signin" className="btn-primary w-full flex items-center justify-center gap-2 py-3">
      Back to Sign In
    </Link>

    <p className="text-xs text-center" style={{ color: 'var(--color-text-tertiary)' }}>
      You can request a new password reset link from the sign in page.
    </p>
  </div>
);
